import type { TagProps } from "./tag.type";

import { Tag as AntdTag } from "antd";
import classNames from "classnames";
import { forwardRef } from "react";

import "./tag.style.less";

export const Tag = forwardRef<HTMLSpanElement, TagProps>((props, ref) => {
  const {
    color,
    variant = "outlined",
    size = "default",
    className,
    children,
    ...tagProps
  } = props;
  /**
   * We need to cast the color prop to a valid value of TagProps["color"] because
   * Antd type don't accept custom hexademical colors, even if Tag component support them.
   */

  return (
    <AntdTag
      ref={ref}
      color={color}
      variant={variant}
      className={classNames(className, {
        [`tag-size-${size}`]: size !== "default",
      })}
      {...tagProps}
    >
      {children}
    </AntdTag>
  );
});

Tag.displayName = "Tag";
